import React from 'react';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../../actions';
import { CONFIG } from '../../../../../config';
import __ from 'lodash';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import LoaderModal from '../../../../modal/LoaderModal';
import Loader from '../../../../Loader';

import GuruMapelEnty from '../../../../../entity/GuruMapel';
import ListGuruMapel from './ListGuruMapel';

import accountManagement from '../../../../../apis/accountManagement';
import KelasSearch from '../../../../../entity/KelasSearch';
import DropdownMapel from '../../masterDropDown/DropdownMapel';
import DropdownKelas from '../../masterDropDown/DropdownKelas';


class MgtKelas extends React.Component{
    constructor(props){
        super(props);
        this.state = {  
            isFetching: false,        
            sekolah:null,
            idSekolah:null,
            kelas:[],
            mapel:[],
            guruMapel:[],
            guruKepalaMapel:[],
            idKelasSelected:null,
            idMapelSelected:null,
            searchInput:null,
            isSearch:false
        }
    }

    async componentDidMount(){
        document.title = "Guru Mapel";
        this.setState({isFetching: true});
        await this.props.cekCookies();
        this.setState({isFetching: false});
        if(!__.isEmpty(this.props.account)){
            this.setState({idSekolah: this.props.account.idSekolah});
            this.fetchKelas();
            this.handleOnClickSearch();
        }
    }

    fetchKelas = async () =>{
        this.setState({isFetching: true});

        //fetch sekolah dulu
        const resSekolah = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_GET_SEKOLAH + this.state.idSekolah).catch(function(error){
        })
        if(resSekolah){
            if(resSekolah.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    sekolah: resSekolah.data.data
                })
            }
        }

        //fetch kelas setelah dapat data sekolah
        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS, {KelasSearch, ["kodeJenjangSekolah"]: this.state.sekolah.kodeJenjangSekolah}).catch(function(error){
        });

        // masukan data kelas ke dropdown
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    kelas: response.data.data
                })
            }
        }
        this.setState({isFetching: false});
    }

    handleOnChangeKelas = async (idKelas) => {
        this.setState({            
            idKelasSelected: idKelas.target.value
        })
        this.setState({isFetching: true});

        //fetch sekolah dulu
        this.setState({mapel:[]})
        const resMapel = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_FETCH_MAPEL_BY_ID_KELAS + idKelas.target.value).catch(function(error){
        })
        if(resMapel){
            if(resMapel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    mapel: resMapel.data.data
                })
            }
        }
        this.setState({isFetching: false});
    }

    handleOnChangeMapel = async (idMapel) =>{
        this.setState({idMapelSelected:idMapel.target.value})
    }

    handleOnChangeInputSearch =(e)=>{
        this.setState({searchInput:e.target.value})
    }

    handleOnClickSearch = async ()=>{
        this.setState({isSearch: true});

        this.setState({guruMapel: []})
        this.setState({guruKepalaMapel: []})
        //fetch kelas pararelnya dulu
        const resGuruMapel = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_FETCH_GURU_MAPEL, {
            ...GuruMapelEnty,
            ["usernameGuru"]: this.state.searchInput,
            ["namaGuru"]: this.state.searchInput,
            ["idMapel"]: this.state.idMapelSelected,
            ["idKelas"]: this.state.idKelasSelected,
            ["idSekolah"]: this.state.idSekolah
        }).catch (function(error){
        })

        if(resGuruMapel){
            if(resGuruMapel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    guruMapel: resGuruMapel.data.data.data
                })
                this.setState({
                    guruKepalaMapel: resGuruMapel.data.data.kepala
                })
            }
        }

        this.setState({isSearch: false});
        this.setState({searchInput:''})
    }

    componentDidUpdate(){

    }

    loading = () =>{
        if(this.state.isSearch){
            return(
                <Loader />
            )
        }
    }

    render(){
        return(
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar />  
                    <div className="row">
                        <div className="col-md-3">
                            <label>Filter Kelas</label>
                            <select className="form-control" value={this.state.idKelasSelected} onChange={this.handleOnChangeKelas} required>
                                <option value="">~~ Pilih Kelas ~~</option>
                                <DropdownKelas kelas={this.state.kelas} />
                            </select>
                        </div>
                        <div className="col-md-3">
                            <label>(Atau) Filter Mata Pelajaran</label>
                            <select className="form-control" value={this.state.idMapelSelected} onChange={this.handleOnChangeMapel} required>
                                <option value="">~~ Pilih Mapel ~~</option>
                                <DropdownMapel mapel={this.state.mapel} />
                            </select>
                        </div>
                        <div className="col-md-3">
                            <label>(Atau) Filter Berdasarkan</label>
                            <input className="form-control" placeholder="Username / Nama Guru" value={this.state.searchInput} onChange={this.handleOnChangeInputSearch}/>
                        </div>
                        <div className="col-md-3">
                            <br />
                            <a className="btn btn-info" onClick={this.handleOnClickSearch}>
                                <i className="fa fa-search"> Cari</i>
                            </a>
                        </div>
                    </div>
                    <br />
                    {this.loading()}
                    <ListGuruMapel dataGuruMapel={this.state.guruMapel} dataKepalaGuruMapel={this.state.guruKepalaMapel} kelas={this.state.kelas} />
                    
                </div>
            </div>
        );
    }


    
}



const mapStateToProps = (state) => {
    return{
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(MgtKelas);